import { FORMAT_TIME } from 'constants/days';
import moment from 'moment';
import React from 'react';
import { metersToMiles } from 'utils';

import { getPaymentText } from '../../AppointmentsTabs/helpers';
import ContactNLabelButtons from '../ContactNLabelButtons';
import { useCommonActionButtonsForAppointments } from '../helpers';
import { INotaryAppointmentType } from '../types';

const HistoryAppointment: React.FC<INotaryAppointmentType> = ({
  appointment,
  transactionTypesData,
  refetchAppointmentData,
}) => {
  // const appointmentAddress = appointment.address;
  const appointmentStartTime = moment(appointment.date).format(FORMAT_TIME).toString();
  const appointmentDuration = (appointment.duration || 0) / 3600;
  const appointmentEndTime = moment(appointment.date).add(appointmentDuration, 'h').format(FORMAT_TIME).toString();

  const {
    contactClick,
    shippingLabelClick,
    generateShippingLabelLoading,
    Modal,
    AppointmentActionButtons,
    appointmentCardClick,
  } = useCommonActionButtonsForAppointments({ refetch: refetchAppointmentData, appointment, transactionTypesData });

  const unreadMessageCount = appointment.chatRoom?.unreadMessagesCount;

  return (
    <>
      {Modal}
      <div
        className='gx-d-flex gx-justify-content-between gx-w-100 common-appointment-by-day-single'
        onClick={appointmentCardClick}>
        <div className='common-appointment-info'>
          <div className='common-appointment-info-main'>
            <div className='gx-font-weight-bold'>
              {appointmentStartTime} - {appointmentEndTime} ({appointmentDuration} hour
              {appointmentDuration > 1 ? 's' : ''})
            </div>
            <div className='description'>Notary Appointment</div>
            <ContactNLabelButtons
              shippingLabelLoading={generateShippingLabelLoading}
              containerClassName='contact-label-button desktop-only'
              contactClick={contactClick}
              shippingLabelClick={shippingLabelClick}
              unreadMessageCount={unreadMessageCount}
              appointment={appointment}
            />
          </div>
          <div className='common-appointment-info-extra'>
            <div>
              <span className='gx-font-weight-medium'>Distance:</span>
              <span> {metersToMiles(appointment?.distance || 0).toFixed(1)} miles</span>
            </div>
            <div>
              <span className='gx-font-weight-medium'>Payment:</span>
              <span> ${getPaymentText(appointment, transactionTypesData).notaryPrice}</span>
            </div>
            <ContactNLabelButtons
              shippingLabelLoading={generateShippingLabelLoading}
              containerClassName='contact-label-button mobile-only'
              contactClick={contactClick}
              shippingLabelClick={shippingLabelClick}
              unreadMessageCount={unreadMessageCount}
              appointment={appointment}
            />
          </div>
          <div className='appointment-info-action-buttons'>
            <AppointmentActionButtons />
          </div>
        </div>
      </div>
    </>
  );
};

export default HistoryAppointment;
